import React from 'react';
import classnames from 'classnames';

import { Badge } from '../material-ui/Badge';
import { Button } from '../material-ui/Button';
import { Leg } from '../../icons';
import { Status } from './constants';

const getLegColor = (classes, status) => {
    switch (status) {
        case Status.SEND:
            return classes.statusSend;
        case Status.EDIT:
            return classes.statusEdit;
    }

    return '';
};

export const getSlides = (legs, currentLeg, showCancel, classes, translate, getLegStatus, onClickLeg, isEng) => {
    return () =>
        legs.map(({ airportTakeOff, airportLanding, flightCancel, flightNum, flightNumEng, id }, index) => ({
            id,
            Component: (
                <Button
                    variant="outlined"
                    onClick={() => onClickLeg(id)}
                    startIcon={<Leg width="20" height="20" className={getLegColor(classes, getLegStatus(id))} />}
                    className={classnames(
                        flightCancel ? classes.cancel : null,
                        classes.button,
                        id === currentLeg?.id ? classes.activeButton : null
                    )}
                >
                    <Badge className={classes.badge} badgeContent={index + 1} />
                    {`${isEng ? flightNumEng : flightNum} ${airportTakeOff.code}-${airportLanding.code}`}
                    {flightCancel && showCancel ? ` (${translate('cancelled')})` : ''}
                </Button>
            ),
        }));
};
